// store/sme/campaignReports.ts
import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface CampaignReportCache {
  campaignMetrics: any;
  campaignDetails: any;
  timestamp: number;
}

export const useSmeCampaignReportStore = defineStore('sme-campaign-report', () => {
  const reportCache = ref<Map<string, CampaignReportCache>>(new Map());
  const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

  const setCampaignReportData = (campaignId: string, metrics: any, details: any) => {
    reportCache.value.set(campaignId, {
      campaignMetrics: metrics,
      campaignDetails: details,
      timestamp: Date.now(),
    });
  };

  const getCampaignReportData = (campaignId: string) => {
    const cached = reportCache.value.get(campaignId);

    if (!cached) return null;

    // Check if cache is still valid
    const isValid = Date.now() - cached.timestamp < CACHE_DURATION;

    if (!isValid) {
      reportCache.value.delete(campaignId);
      return null;
    }

    return cached;
  };

  const clearCampaignReportData = (campaignId: string) => {
    reportCache.value.delete(campaignId);
  };

  const clearAllReportData = () => {
    reportCache.value.clear();
  };

  return {
    setCampaignReportData,
    getCampaignReportData,
    clearCampaignReportData,
    clearAllReportData,
  };
});
